import * as React from "react";
import { Text, View } from "react-native";
import * as ImagePicker from "expo-image-picker";
import { decodeEntity } from "html-entities";
import { useWatch } from "react-hook-form";

import { getImageSize } from "~/utils/getImageSize";
import { Image } from "~/components/Image";
import {
  SaveFormValues,
  useSaveFormContext,
} from "~/components/SaveForm/shared";
import { useGetR2AssetURL } from "~/hooks/useGetR2AssetURL";
import { blurhash } from "~/lib/constants";
import { formatBytes } from "~/lib/utils";

export function MediaPreviewCard() {
  const mediaMeta = useWatch<SaveFormValues, "mediaMeta">({
    name: "mediaMeta",
  });
  const r2Key = useWatch<SaveFormValues, "r2Key">({ name: "r2Key" });

  const { setValue } = useSaveFormContext();
  const { getR2AssetURL } = useGetR2AssetURL();
  if (!mediaMeta) return null;

  return (
    <View className="flex-row gap-4">
      <View className="flex-1">
        <Image
          source={mediaMeta?.uri || getR2AssetURL(r2Key)}
          placeholder={blurhash}
          style={{
            flex: 1,
            // height: 80,
            height: 100,
            borderRadius: 8,
          }}
          contentFit="cover"
          alt={mediaMeta?.fileName}
        />
      </View>
      <View className="flex-1 gap-2">
        <View className="flex-row items-center gap-1">
          {mediaMeta?.fileName && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              className="text-text-primary shrink font-semibold"
            >
              {mediaMeta.fileName}
            </Text>
          )}
        </View>
        <View>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            className="text-text-secondary shrink text-sm"
          >
            {mediaMeta?.type} {decodeEntity("&bull;")}{" "}
            {formatBytes(mediaMeta.fileSize ?? 0)}
          </Text>
        </View>

        <Text
          className="text-text-brand"
          onPress={async () => {
            try {
              await ImagePicker.requestMediaLibraryPermissionsAsync();
              const result = await ImagePicker.launchImageLibraryAsync({
                mediaTypes: ImagePicker.MediaTypeOptions.All,
                presentationStyle:
                  ImagePicker.UIImagePickerPresentationStyle.FORM_SHEET,
              });

              if (!result.canceled) {
                const asset = result.assets[0];
                setValue("mediaMeta", {
                  type: asset?.type === "video" ? "video" : "image",
                  uri: asset?.uri ?? "",
                  assetId: asset?.assetId ?? "",
                  duration: asset?.duration ?? 0,
                  fileName: asset?.fileName ?? "",
                  height: asset?.height ?? 0,
                  fileSize: asset?.fileSize ?? getImageSize(asset.uri),
                  width: asset?.width ?? 0,
                  mimeType: asset?.mimeType ?? "",
                });
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          Select another
        </Text>
      </View>
    </View>
  );
}
